<script>
    import EmptyListItem from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/EmptyListItem.svelte?1733898724719';
    import ListItem from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/ListItem.svelte?1733898724719';
    import { onMount } from 'svelte';
    import { register } from 'swiper/element/bundle';
    import { load_product } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/api-client/product/load_product.js?1733898724719';
    import Id from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/id.js?1733898724719';
    import { get_attribute_value } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/attributes.js?1733898724719';
    import { messages } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/stores/messages.js?1733898724719';

    wyvr: {
        render: 'hydrate';
    }

    // register swiper slider
    register();

    export let title = null;
    export let products = [];
    export let store = 'de';
    export let locale = 'de';
    export let currency = 'EUR';
    export let breakpoints;
    export let navigation = { enabled: false };
    export let pagination = { enabled: false };
    export let autoplay = true;
    export let id;

    let slidesPerView = 1;
    let products_per_page = 4;

    let slider;

    let items = [];

    ;
    onMount(() => {
        get_items().then((result) => {
            items = result;
        });
        breakpoints = getBreakpoints();
        navigation = {
            enabled: true,
            nextEl: `#slider${id}-next`,
            prevEl: `#slider${id}-prev`
        };
        pagination = {
            enabled: true,
            el: `#slider${id}-pagination`,
            bulletClass: 'c-slider-bullet',
            bulletActiveClass: 'c-slider-bullet-active',
            clickable: true
        };
    });

    async function get_items() {
        const itemsCache = [];

        if (!Array.isArray(products)) {
            return itemsCache;
        }

        // Use map to create an array of promises
        const productPromises = products.map(async (item) => {
            const sku = get_attribute_value(item, 'sku');
            if (!sku) {
                return null;
            }
            const [error, product] = await load_product(sku);
            if (error) {
                messages.push(window.__('shop.internal_error', error), 'error');
                return null; // Returning null for the failed case
            }
            // load_product returns a not found product
            if (product === null) {
                return null; // Remove the product when not able to be found
            }
            // check stock
            const in_stock = product?.quantity_and_stock_status?.value?.is_in_stock && product?.status?.value === '1';
            if (in_stock) {
                itemsCache.push(product);
            }
        });

        // Wait for all promises to settle before returning itemsCache
        await Promise.all(productPromises);

        return itemsCache;
    }

    function getBreakpoints() {
        return {
            400: {
                slidesPerView: Math.max(1, Math.ceil(products_per_page / 4))
            },
            500: {
                slidesPerView: Math.max(1, Math.ceil(products_per_page / 3))
            },
            600: {
                slidesPerView: Math.max(1, Math.ceil(products_per_page / 2.5))
            },
            768: {
                slidesPerView: Math.max(1, Math.ceil(products_per_page / 2))
            },
            1024: {
                slidesPerView: Math.max(1, Math.ceil(products_per_page / 1.5))
            },
            1280: {
                slidesPerView: products_per_page
            }
        };
    }
</script>

{#if items && items.length > 0}
    <section class="c-slider-container">
        {#if title}
            <h2>{title}</h2>
        {/if}

        <div class="c-product-slider c-slider__container">
            <div class="c-slider__button c-slider__button-prev" id="slider{id}-prev">
                <i class="ri-arrow-left-s-line" />
            </div>
            <div class="c-slider__button c-slider__button-next" id="slider{id}-next">
                <i class="ri-arrow-right-s-line" />
            </div>
            <div id="slider{id}-pagination" class="c-slider__pagination" />

            <swiper-container
                bind:this={slider}
                slides-per-view={slidesPerView}
                centered-slides={false}
                {breakpoints}
                {navigation}
                {pagination}
                loop={false}
                autoplay-delay={autoplay ? 5000 : undefined}
                autoplay-disable-on-interaction={autoplay}
            >
                {#each items as product}
                    <swiper-slide>
                        <div class="slide">
                            {#if product}
                                <ListItem {product} {store} {locale} {currency} />
                            {:else}
                                <EmptyListItem />
                            {/if}
                        </div>
                    </swiper-slide>
                {/each}
            </swiper-container>
        </div>
    </section>
{/if}


<style>
    .c-product-slider {
        min-height: 510px;
    }

    swiper-container {
        padding-bottom: 40px;
    }

    .c-slider__pagination {
        display: flex;
        justify-content: center;
        position: absolute;
        bottom: 0;
        width: 100%;
    }

    .c-product-slider :global(.c-slider-bullet) {
        display: inline-block;
        width: 16px;
        height: 16px;
        overflow: hidden;
        padding: 0;
        background: #000;
        opacity: 0.54;
        border: none;
        color: rgba(0, 0, 0, 0);
        margin-left: 8px;
        position: relative;
        transition:
            width 0.2s ease,
            opacity 0.2s linear;
        border-radius: 8px;
        cursor: pointer;
    }

    .c-product-slider :global(.c-slider-bullet-active) {
        width: 32px;
        opacity: 1;
    }

    swiper-slide {
        height: auto;
        display: flex;
        align-items: center;
    }

    .slide {
        align-self: flex-start;
        width: 100%;
        padding: 10px;
        height: 100%;
    }

    .slide :global(.old-price) {
        display: block !important;
        margin-left: 0 !important;
    }

    .c-slider__button-next,
    .c-slider__button-prev {
        height: 100%;
        display: flex;
        align-items: center;
        cursor: pointer;
        font-size: 2.5rem;
    }

    .c-slider__button-next {
        width: auto;
        justify-content: flex-end;
    }

    .c-slider__button-prev {
        width: 40px;
        justify-content: flex-start;
    }

    .slide :global(.product) {
        height: 100%;
    }

    h2 {
        margin-bottom: 0;
    }
</style>